import { useAuthStore } from "@/stores/useAuthStore";

export function useAuth() {
  const { session, isLoading, isOnboarded, profileSynced } = useAuthStore();

  const role = session?.role ?? "user";

  return {
    session,
    isLoading,
    isOnboarded,
    profileSynced,
    isAuthenticated: !!session,
    userId: session?.userId ?? null,
    displayName: session?.displayName ?? null,
    role,
    isAdmin: role === "admin",
  };
}
